// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Login, lock screen and forgot password. Root: .auth-page */
.auth-page {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  min-height: 100dvh;
  padding: calc(var(--ds-space-4) + var(--ds-safe-top))
    calc(var(--ds-space-4) + var(--ds-safe-right)) calc(var(--ds-space-4) + var(--ds-safe-bottom))
    calc(var(--ds-space-4) + var(--ds-safe-left));
  background: var(--ds-bg);
}

.auth-page__card {
  width: 100%;
  max-width: 420px;
  padding: var(--ds-space-6) var(--ds-space-5);
  background: var(--ds-surface);
  border: 1px solid var(--ds-border-soft);
  border-radius: var(--ds-radius-xl);
  box-shadow: var(--ds-shadow-md);
}

.auth-page__logo {
  display: block;
  width: auto;
  max-width: 180px;
  max-height: 56px;
  margin: 0 auto var(--ds-space-5);
}

.auth-page__title {
  margin: 0 0 var(--ds-space-1);
  font-size: 1.5rem;
  font-weight: 700;
  text-align: center;
  color: var(--ds-text);
}

.auth-page__subtitle {
  margin: 0 0 var(--ds-space-5);
  text-align: center;
  color: var(--ds-text-2);
}

.auth-page__user {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--ds-space-2);
  margin-bottom: var(--ds-space-5);
}

.auth-page__user h4 {
  margin: 0;
  font-size: 1.125rem;
  color: var(--ds-text);
}

.auth-page__field {
  margin-bottom: var(--ds-space-4);
}

.auth-page__label {
  display: block;
  margin-bottom: var(--ds-space-1);
  font-weight: 500;
  color: var(--ds-text);
}

/* iOS zooms into fields under 16px; these pages are phone-first. */
.auth-page .ant-input,
.auth-page .ant-input-affix-wrapper input {
  font-size: 16px;
}

.auth-page__footer {
  margin-top: var(--ds-space-5);
  text-align: center;
  color: var(--ds-text-2);
}

@media (min-width: 768px) {
  .auth-page__card {
    padding: var(--ds-space-8);
  }
}
`, "",{"version":3,"sources":["webpack://./src/serviceProvider/components/login/login.css"],"names":[],"mappings":"AAAA,6DAA6D;AAC7D;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB;;iDAE+C;EAC/C,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,4CAA4C;EAC5C,6BAA6B;EAC7B,uCAAuC;EACvC,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,mEAAmE;AACnE;;EAEE,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* Login, lock screen and forgot password. Root: .auth-page */\n.auth-page {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  min-height: 100dvh;\n  padding: calc(var(--ds-space-4) + var(--ds-safe-top))\n    calc(var(--ds-space-4) + var(--ds-safe-right)) calc(var(--ds-space-4) + var(--ds-safe-bottom))\n    calc(var(--ds-space-4) + var(--ds-safe-left));\n  background: var(--ds-bg);\n}\n\n.auth-page__card {\n  width: 100%;\n  max-width: 420px;\n  padding: var(--ds-space-6) var(--ds-space-5);\n  background: var(--ds-surface);\n  border: 1px solid var(--ds-border-soft);\n  border-radius: var(--ds-radius-xl);\n  box-shadow: var(--ds-shadow-md);\n}\n\n.auth-page__logo {\n  display: block;\n  width: auto;\n  max-width: 180px;\n  max-height: 56px;\n  margin: 0 auto var(--ds-space-5);\n}\n\n.auth-page__title {\n  margin: 0 0 var(--ds-space-1);\n  font-size: 1.5rem;\n  font-weight: 700;\n  text-align: center;\n  color: var(--ds-text);\n}\n\n.auth-page__subtitle {\n  margin: 0 0 var(--ds-space-5);\n  text-align: center;\n  color: var(--ds-text-2);\n}\n\n.auth-page__user {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--ds-space-2);\n  margin-bottom: var(--ds-space-5);\n}\n\n.auth-page__user h4 {\n  margin: 0;\n  font-size: 1.125rem;\n  color: var(--ds-text);\n}\n\n.auth-page__field {\n  margin-bottom: var(--ds-space-4);\n}\n\n.auth-page__label {\n  display: block;\n  margin-bottom: var(--ds-space-1);\n  font-weight: 500;\n  color: var(--ds-text);\n}\n\n/* iOS zooms into fields under 16px; these pages are phone-first. */\n.auth-page .ant-input,\n.auth-page .ant-input-affix-wrapper input {\n  font-size: 16px;\n}\n\n.auth-page__footer {\n  margin-top: var(--ds-space-5);\n  text-align: center;\n  color: var(--ds-text-2);\n}\n\n@media (min-width: 768px) {\n  .auth-page__card {\n    padding: var(--ds-space-8);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
